
const CACHE_PREFIX = 'xleven_v1_';

// 동일 키로 진행 중인 요청이 있으면 새 요청을 보내지 않고 기존 Promise를 반환
const _pending = new Map<string, Promise<any>>();
export const dedupRequest = <T>(key: string, fn: () => Promise<T>): Promise<T> => {
  const existing = _pending.get(key);
  if (existing) return existing as Promise<T>;
  const promise = fn().finally(() => _pending.delete(key));
  _pending.set(key, promise);
  return promise;
};
const DEFAULT_TTL = 1000 * 60 * 60 * 2; // 2 Hours

export const saveToCache = <T>(key: string, data: T, ttl: number = DEFAULT_TTL): void => {
  try {
    const item = {
      value: data,
      expiry: Date.now() + ttl,
    };
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(item));
  } catch (e) {
    console.warn('LocalStorage save failed', e);
  }
};

export const getFromCache = <T>(key: string): T | null => {
  try {
    const itemStr = localStorage.getItem(CACHE_PREFIX + key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return item.value;
  } catch (e) {
    return null;
  }
};

export const clearCache = (key?: string) => {
  if (key) {
    localStorage.removeItem(CACHE_PREFIX + key);
  } else {
    Object.keys(localStorage).forEach((k) => {
      // xleven_v1_ 접두사로 시작하는 키만 삭제하되,
      // Supabase 인증 관련 키나 기타 시스템 키는 건드리지 않음
      if (k.startsWith(CACHE_PREFIX)) {
        localStorage.removeItem(k);
      }
    });
  }
};
